import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

//#region primeng module
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api'
//#endregion

//#region components
import { LoadingAnimationComponent } from './components/loading-animation/loading-animation.component';
//#endregion

//#region translate
import { TranslateModule } from '@ngx-translate/core';
//#endregion

//#region services
import { PoliceGuardService } from './services/police-guard.service';
import { RoleGuardService } from './services/role-guard.service';
//#endregion

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        ButtonModule,
        CalendarModule,
        DropdownModule,
        DialogModule,
        DynamicDialogModule,
        FormsModule,
        InputTextModule,
        SplitButtonModule,
        TableModule,
        PaginatorModule,
        ToastModule,
        TranslateModule,
    ],
    declarations: [
        LoadingAnimationComponent
    ],
    providers: [
        PoliceGuardService,
        RoleGuardService,
        DatePipe,
        MessageService
    ],
    exports: [
        CommonModule,
        HttpClientModule,
        ButtonModule,
        CalendarModule,
        DropdownModule,
        DialogModule,
        DynamicDialogModule,
        FormsModule,
        InputTextModule,
        LoadingAnimationComponent,
        SplitButtonModule,
        TableModule,
        PaginatorModule,
        ToastModule,
        TranslateModule
    ]
})
export class SharedModule { }
